import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Modal, {
  ModalBody,
  ModalTitle,
  ModalHeader,
  ModalFooter,
} from '@atlaskit/modal-dialog';

import messages from './discard-changes-dialog.i18n';

type Props = {
  intl: InjectedIntl;
  onCancel: () => void;
  onConfirm: () => void;
};

class FileEditCancelConfirmDialog extends PureComponent<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    onCancel: () => {},
    onConfirm: () => {},
  };

  render() {
    const { intl } = this.props;

    return (
      <Modal
        // Default to the non-destructive action
        onClose={this.props.onCancel}
        width="small"
      >
        <ModalHeader>
          <ModalTitle appearance="danger">
            {intl.formatMessage(messages.heading)}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <FormattedMessage {...messages.body} tagName="p" />
        </ModalBody>
        <ModalFooter>
          <CustomThemeButton
            onClick={() => this.props.onConfirm()}
            appearance="primary"
          >
            {this.props.intl.formatMessage(
              messages.confirmDiscardChangesButton
            )}
          </CustomThemeButton>
          <CustomThemeButton
            onClick={() => this.props.onCancel()}
            appearance="subtle"
          >
            {this.props.intl.formatMessage(messages.cancelDiscardChangesButton)}
          </CustomThemeButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default injectIntl(FileEditCancelConfirmDialog);
